<template>
	<div class="display-inline-flex flex-align-center radio-menu-container">
		<AnemicButton
			:key="option.value"
			class="radio-menu-button"
			v-for="option in options"
			:class="{ selected: value === option.value }"
			@click="(value) => buttonClickedHandler(option, value)"
		>
			<MaybeUpgradeRequiredIndicator :billingFeatureId="option.billingFeatureId" v-if="option.billingFeatureId">
				<template #default="{ indicator, isUpgradeRequired }">
					<Row>
						{{ option.text }}
						<component class="ml-2" v-if="isUpgradeRequired" :is="indicator" :billingFeatureId="option.billingFeatureId" iconOnly />
					</Row>
				</template>
			</MaybeUpgradeRequiredIndicator>
			<template v-else>
				{{ option.text }}
			</template>
		</AnemicButton>
	</div>
</template>
<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';

export default {
	name: 'RadioMenu',
	components: { MaybeUpgradeRequiredIndicator },
	props: {
		value: { required: false },
		options: { type: Array, required: true },
	},
	methods: {
		buttonClickedHandler(option, value) {
			if (option.value !== value) {
				this.$emit('selected', option.value);
			}
		},
	},
};
</script>
<style scoped lang="scss">
.radio-menu-container {
	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;
	height: 26px;
	width: auto;

	.radio-menu-button {
		height: 26px !important;
		padding: 3px 6px !important;
		font-size: 12px !important;
		color: #666767 !important;
		border-radius: 6px !important;
		font-weight: normal !important;
		background: transparent !important;

		&.selected {
			color: #6363ed !important;
			border: 1px solid #e7eaf3 !important;
			background: var(--bg-color) !important;
			box-shadow: 0px 1px 2px var(--shadow-color) !important;
		}
	}
}
</style>
